// Фун-я получения константы для метода add
const getAddDateUnit = unit => {
  switch (unit) {
    case `YEAR`:
      return `y`
    case `MONTH`:
      return `M`
    case `WEEK`:
      return `w`
    default:
      return `d`
  }
}

export default getAddDateUnit
